import { useAppContext } from "@context/app";
import { IAddressFieldsInput, IAreaDetailInput, IAreaInput } from "@types";
import { COOKIE_AREA_KEY } from "@utils/constants";
import { getCookie } from "@utils/Cookies";
import { commonApi } from "gate";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { BsX } from "react-icons/bs";
import AddressForm from "./addressForm";
import useRequestImmutable from "@hooks/useRequestImmutable";

interface AddressProps {
  id?: number;
  onClose?: (data: boolean) => void;
  data?: IAddressFieldsInput;
  action?: (data: IAddressFieldsInput) => void;
}

const Address: React.FC<AddressProps> = ({ data, id, onClose, action }) => {
  const { country } = useAppContext();
  const Cookies = getCookie();
  const t = useTranslations();
  const [areaList, setAreaList] = useState<IAreaInput[]>([]);
  const [selectedArea, setSelectedArea] = useState<
    IAreaDetailInput | undefined
  >(undefined);
  const [useMap, setUseMap] = useState(false);
  const [mapValue, setMapValue] = useState<{
    street: string;
    lat: number;
    lng: number;
  }>({
    street: "",
    lat: 29.372182,
    lng: 47.982538,
  });

  const { data: areas } = useRequestImmutable(
    country ? commonApi.getAreaList(country.id) : undefined
  );
  useEffect(() => {
    if (areas) {
      setAreaList(areas.data.items);
    }
  }, [areas]);

  useEffect(() => {
    const _area = Cookies.get(COOKIE_AREA_KEY)
    for (const area of areaList) {
      for (const c of area.items) {
        if (c.id === Number(data?.area_id ?? _area)) {
          submitAreaView({ ...c, parentName: area.name });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, areaList]);

  const submitAreaView = async (area: IAreaDetailInput) => {
    setSelectedArea(area);
    setMapValue({ ...area.center, street: "" });
  };

  const handleAutofillAreaChange = (areaId: number) => {
    for (const area of areaList) {
      if (area.id === areaId) {
        submitAreaView(area);
        return;
      }

      for (const childArea of area.items) {
        if (childArea.id === areaId) {
          submitAreaView({ ...childArea, parentName: area.name });
          return;
        }
      }
    }
  };

  const handelSubmit = (address: IAddressFieldsInput) => {
    onClose?.(false);
    action?.(address);
  };

  const handelUseMap = (value: boolean) => {
    setUseMap(value);
  };

  const submitMapView = (data: {
    street: string;
    lat: number;
    lng: number;
  }) => {
    setMapValue(data);
  };

  return (
    <div className=" sm:min-w-[420px] w-full ">
      <div className=" w-full flex flex-wrap mb-5 items-center">
        <p className="w-10 text-[#999]">
        </p>
        <p className="flex-1 font-normal text-xl text-[#333] text-center">
          {id ? t("client_general_editaddress") : t("client_address_newaddress")}
        </p>
        <p className="w-10 text-[#999] flex justify-end">
          <BsX
            size={24}
            className=" cursor-pointer"
            onClick={() => onClose?.(false)}
          />
        </p>
      </div>
      {selectedArea && (
        <AddressForm
          area={selectedArea}
          onSubmit={handelSubmit}
          mapValue={mapValue}
          defaultValue={data}
          useMap={useMap}
          setUseMap={handelUseMap}
          id={data?.id}
          changeArea={submitAreaView}
          changeMap={submitMapView}
          setMapPosition={submitMapView}
          onAutofillAreaChange={handleAutofillAreaChange}
        />
      )}
    </div>
  );
};

export default Address;
